// helpers/productSorters

export function hotDealsAtTop_NoDealOfTheMonth(inArr) {
	/* 
		This function retains the current provided object array
		sorting, moves hot deals to the start
		and returns the resulting array
	*/
	console.log("CALLED");

  const noHotDealsArr = [];
  const hotDealsArr = [];

  inArr.map((thisObj,x) => {

		if (!dealOfTheMonthTest(thisObj)) {
	  	if (thisObj.Discount > 0) {
					hotDealsArr.push(thisObj)
	  	} else {
		  		noHotDealsArr.push(thisObj)
	  	}
		}

  });

  return [...hotDealsArr, ...noHotDealsArr];

}


export function dealOfTheMonthTest(inObj) {
	/* 
		This function takes a product object and decides if it is a current
		Deal Of The Month
	*/

	const currentDate = new Date();
	const currentDateISO = currentDate.toISOString();

	// Create two Date objects
	const startDate = new Date(inObj.DealOfMonthStart);
	const endDate = new Date(inObj.DealOfMonthStop);
	// Convert the dates to ISO strings
	const startDateISO = startDate.toISOString();
	const endDateISO = endDate.toISOString();

	if ((currentDateISO > startDateISO) && (currentDateISO < endDateISO) && (inObj.Live === true)) {
		console.log(inObj.ID, "NO",currentDateISO,startDateISO,endDateISO  )
		return true
	} else {
		return false
	}

}


export function dealOfTheMonthArr(inArr) {
	/* 
		Looks through the provided product array
		and pulls out and returns an array 
		of any Deals of The Month
	*/

  const newArr = [];

  inArr.map((thisObj,x) => {

  	if (dealOfTheMonthTest(thisObj) && thisObj.Live) {
  		newArr.push({...thisObj})
  	}

  });

  return newArr;

}

export function sortProductsByPriceAndName(inArr, order, curLanguage) {

	//order = hightolow or lowtohigh

  let sortedProducts = inArr.sort(
    (a, b) => {
      var textA = a[`Name${curLanguage}`].toUpperCase();
      var textB = b[`Name${curLanguage}`].toUpperCase();

      if (order === 'lowtohigh') {
          if ((a.Price-a.Discount) === (b.Price-b.Discount)){
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          } else {
            return (a.Price-a.Discount) - (b.Price-b.Discount)
          }
      } else {
          if ((a.Price-a.Discount) === (b.Price-b.Discount)){
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          } else {
            return (b.Price-b.Discount) - (a.Price-a.Discount)
          }
      }
    }
  )

  return sortedProducts;

}